(function ($) {
	$.fn.dfpAds = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}

};

}(jQuery));
